/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Templates_DeletedInputs */

const cs_templates_deleted = /** @type {(inputs: Templates_DeletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Šablona smazána`)
};

const en_templates_deleted = /** @type {(inputs: Templates_DeletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Template deleted`)
};

/**
* | output |
* | --- |
* | "Template deleted" |
*
* @param {Templates_DeletedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const templates_deleted = /** @type {((inputs?: Templates_DeletedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Templates_DeletedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_templates_deleted(inputs)
	return cs_templates_deleted(inputs)
});